import React, { useContext, useState } from 'react'
import close from "./../inventory-new/alerts/icons/close.svg"
import styles from "./TopBanner.module.css"
import { UserDetailsContext } from 'App';
import { IAM_API } from 'common-ui-components/components/utils/IAM_API';
import API from 'common-ui-components/components/utils/API'
import { notify } from 'common-ui-components/components/notification/Notification';
import { Failure, Success } from 'common-ui-components/components/notification/templates';
import Spinner from 'common-ui-components/components/ResponseLoader/Spinner/Spinner';
const TopBanner = ({ msg = null, setOpenBanner = null, type = null, showSimulationDataBanner = false }) => {
  const userDetails = useContext(UserDetailsContext);
  const email = userDetails.email || "";

  const [isDisabling, setIsDisabling] = useState(false);

  const verifyEmail = async (setLoading) => {
    setLoading(true);
    try {
      const response = await IAM_API.post(`/user/verification-resend`);
      if (response.data.status === true) {
        if (response.data.statusCode === 201) {
          notify(<Success> Your email had been verified already.</Success>)
          userDetails.setUserDetails({ ...userDetails, verified: true })
        }
        else
          notify(<Success> The email has been sent. Please verify by clicking the link in the mail.</Success>)
      }
      else
        notify(<Failure> Failed in sending the verification email </Failure>)
    }
    catch (error) {
      console.error(error);
    }
    setLoading(false);
  }
  //for stop simulation disabling dummy devices 
  const stopSimulationData = async () => {
    setIsDisabling(true);
    try {
      const response = await API.put("/inventory/disable-sample-data?dataType=devices");
      if (response.status) {
        window.location.reload();
      } else {
        notify(
          <Failure>
            Unable to turn off the setting at the moment.
          </Failure>
        );
      }
    } catch (error) {
      console.error(error);
      notify(
        <Failure>
          Unable to turn off the setting at the moment.
        </Failure>
      );
    }
    finally {
      setIsDisabling(false); 
    }
  };

  const ExtraComponent = () => {
    const [loading, setLoading] = useState(false);
    return (
      <span>
        {loading ? (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span>Sending Email</span>
            <Spinner color="black" size="1rem" />
          </span>
        ) : (
          type === "emailVerification" && (
            <a
              className={styles.link}
              onClick={() => verifyEmail(setLoading)}>
              Verify 
            </a>
          )
        )}
      </span>
    );
  };
  
  if (type === "emailVerification") {
    return (
      <div className={styles.container} style={{ ...({ gap: "10px" }) }}>
        <span>{userDetails?.verified === false && (
    <>
      Your account <a style={{color: "#0b0b0b",fontWeight: 600,}}>
        {email}</a> is not verified. Please{" "}<ExtraComponent />{" "}
    </>
  )}

    {userDetails?.verified === false &&
      showSimulationDataBanner && " | "}

    {showSimulationDataBanner && (
      <>
      <span style={{ marginRight: "8px" }}>
        Stop seeing simulation data?
      </span>
      {isDisabling ? (
        <span style={{ color: "#D82323", opacity: 0.7, cursor: "not-allowed" }}>
          Disabling...
        </span>
        ) : (
          <a 
            className={styles.link}
            style={{ color: "#D82323" }}
            onClick={stopSimulationData}
          >
            Disable now
          </a>
        )}
      </>
    )}
      </span>
      </div>
    )
  }

  return (
    <div>
      {setOpenBanner === null ? (
        <div className={styles.container} style={{ ...({ gap: "10px" }) }}>
          <div>{msg}</div>
          <ExtraComponent />
        </div>
      ) : (
        <div className={styles.container} style={{ ...({ gap: "10px" }) }}>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div>{msg}</div>
            <ExtraComponent />
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            <img src={close} width={15} height={15} style={{ cursor: "pointer" }} onClick={() => setOpenBanner(false)} />
          </div>
        </div>
      )}
    </div>
  )
}

export default TopBanner